import React, { useState } from "react";
import { ButtonBase, Grid } from "@mui/material";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { StyledButton } from "../../../common/components/Button";
import { normalizeDateTime2 } from "../../../common/helpers/normalizeDateTime";
import { onlineConsultDone, leadProgressDone } from "../../../api/caseApi";
import { f2fConsultDone } from "../../../api/caseApi";
import PayCaseProgressDialog from "./PayCaseProgressDialog";
import UpdateDueDateDialog from "./UpdateDueDateDialog";
import { useNavigate } from "react-router-dom";
import SubmitDesignDialog from "./SubmitDesignDialog";
import ReviewDesignDialog from "./ReviewDesignDialog";
import ViewReviewDialog from "./ViewReviewDialog";
import ViewTreatmentPlanDialog from "./ViewTreatmentPlanDialog";
import { isOnlinePayment } from "../../../common/helpers/isOnlinePayment";
import PaymentEmailDialog from "./PaymentEmailDialog";
import { StyledH3 } from "../../../common/components/Title/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import GeneratePaymentLinkDialog from "./GeneratePaymentLinkDialog";
import { isCaseProgressDone } from "../../../common/helpers/isCaseProgressDone";
import isCaseTerminated from "../../../common/helpers/isCaseTerminated";
import { faComment } from "@fortawesome/free-solid-svg-icons";
export const StatusGridContainer = styled("div")(() => ({
  fontFamily: "Inter",
}));

const CaseStatusGrid = ({
  caseDetails,
  getCaseStatusData,
  handleOpenUpdateNoOfSets,
  getPaymentTransactions,
  leadProgressInfo,
  onlineConsultationInfo,
  f2fConsultationInfo,
  scanningInfo,
  designInfo,
  reviewDesignInfo,
  handleOpenAlert,
  handleSetAlertMessage,
  handleOpenCommentSection,
  currentCaseProgress,
  handleSetCurrentCaseProgress,
  firstDesignCaseProgress,
  firstReviewCaseProgress,
}) => {
  const user = useSelector((state) => state.user);
  const [isDialogOpen, setIsDialogOpen] = useState({
    submitDesign: false,
    reviewDesign: false,
    viewReview: false,
    viewTreatmentPlan: false,
  });
  console.log(reviewDesignInfo);
  const [openUpdateDueDate, setOpenUpdateDueDate] = useState(false);
  const [openPayCaseProgress, setOpenPayCaseProgress] = useState(false);
  const [openSendPaymentEmail, setOpenPaymentEmail] = useState(false);
  const [openGeneratePaymentLink, setOpenGeneratePaymentLink] = useState(false);

  const [disableButton, setDisableButton] = useState(false);
  const navigate = useNavigate();

  const handleCloseUpdateDueDate = () => {
    setOpenUpdateDueDate(false);
  };

  const handleOpenPayCaseProgress = () => {
    setOpenPayCaseProgress(true);
  };

  const handleCloseGeneratePaymentLink = () => {
    setOpenGeneratePaymentLink(false);
  };

  const handleOpenGeneratePaymentLink = () => {
    setOpenGeneratePaymentLink(true);
  };
  const handleClosePayCaseProgress = () => {
    setOpenPayCaseProgress(false);
  };

  const handleDone = async (id, type) => {
    if (type === "lead") {
      await leadProgressDone(id);
    } else if (type === "online consultation") {
      if (caseDetails.dentistId == null) {
        handleOpenAlert();
        handleSetAlertMessage("Select your dentist first");
      } else {
        await onlineConsultDone(id);
      }
    } else if (type === "f2f consultation") {
      if (
        (caseDetails.termsOfPayment1Id == null ||
          caseDetails.termsOfPayment1.inActive) &&
        caseDetails.dentistId == null
      ) {
        handleOpenAlert();
        handleSetAlertMessage(
          "Select your dentist and terms of payment before design first"
        );
      } else if (
        (caseDetails.termsOfPayment1Id == null ||
          caseDetails.termsOfPayment1.inActive) &&
        caseDetails.dentistId != null
      ) {
        handleOpenAlert();
        handleSetAlertMessage(
          "Select your terms of payment before design first"
        );
      } else if (
        caseDetails.termsOfPayment1Id != null &&
        caseDetails.dentistId == null
      ) {
        handleOpenAlert();
        handleSetAlertMessage("Select your dentist first");
      } else {
        await f2fConsultDone(id);
      }
    }
    await getCaseStatusData();
  };

  const handleEmailSent = () => {
    handleOpenAlert();
    handleSetAlertMessage("Email sent", true);
  };

  const handleEmailError = (message) => {
    handleOpenAlert();
    handleSetAlertMessage(message);

    getCaseStatusData();
  };

  const DoneIcon = ({ isNotApplicable }) => {
    return (
      <div
        style={{
          fontFamily: "Inter",
          color: "Black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "13px",
          fontWeight: "700",
          borderRadius: "50px",
          width: "130px",
          marginRight: "10px",
        }}
      >
        {isNotApplicable ? <>NOT APPLICABLE</> : <>DONE</>}
      </div>
    );
  };

  const leadStatus = normalizeDateTime2(leadProgressInfo?.createdDate) ?? null;

  const isOnlineConsultEditable =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    onlineConsultationInfo?.dueDate == null &&
    caseDetails?.status === "For online consultation";

  const onlineConsultStatus =
    normalizeDateTime2(onlineConsultationInfo?.dueDate) ?? null;

  const isOnlineConsultPayRequired =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    onlineConsultationInfo?.isPaymentRequired === true &&
    onlineConsultationInfo?.isPaid === false;

  const isOnlineConsultDoneAllowed =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    onlineConsultationInfo?.dueDate != null &&
    caseDetails?.status === "For online consultation";

  const f2fConsultStatus =
    caseDetails.status === "For F2F consultation" ||
    isCaseProgressDone("For online consultation", caseDetails)
      ? normalizeDateTime2(f2fConsultationInfo?.dueDate) ??
        "Add appointment date"
      : null;

  const isF2FConsultPayRequired =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    f2fConsultationInfo?.isPaymentRequired === true &&
    f2fConsultationInfo?.isPaid === false;

  const isF2FConsultEditable =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    f2fConsultationInfo?.dueDate == null &&
    caseDetails?.status === "For F2F consultation";

  const isF2FConsultDoneAllowed =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    f2fConsultationInfo?.dueDate != null &&
    caseDetails?.status === "For F2F consultation";

  const isScanningPayRequired =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    scanningInfo?.isPaymentRequired === true &&
    scanningInfo?.isPaid === false;

  const isScanUploadAllowed =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    caseDetails?.status === "For scanning";

  const scanUploadStatus =
    caseDetails?.status === "For scanning"
      ? "Waiting for files to be uploaded"
      : isCaseProgressDone("For scanning", caseDetails)
      ? "Scan files uploaded"
      : null;

  const isDesignPayRequired =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    designInfo?.isPaymentRequired === true &&
    designInfo?.isPaid === false;

  const designStatus =
    caseDetails.status === "Design in progress"
      ? "Waiting for design"
      : isCaseProgressDone("Design in progress", caseDetails)
      ? "Design uploaded"
      : null;

  const isDesignSubmissionAllowed =
    user.roles.includes("Operations") &&
    caseDetails.status === "Design in progress";

  const isReviewDesignPayRequired =
    (user.roles.includes("Dentist") || user.roles.includes("Operations")) &&
    reviewDesignInfo?.isPaymentRequired === true &&
    reviewDesignInfo?.isPaid === false;

  const isViewReviewAllowed =
    reviewDesignInfo !== null && reviewDesignInfo.isApproved !== null;

  const reviewDesignStatus =
    caseDetails.status === "For design approval"
      ? "Waiting for approval"
      : reviewDesignInfo != null && reviewDesignInfo.isApproved === true
      ? "Approved"
      : reviewDesignInfo != null && reviewDesignInfo.isApproved === false
      ? "Rejected"
      : null;

  const isEditSetsAllowed =
    caseDetails.status === "Design approved" &&
    user.roles.includes("Operations");

  const isViewRxAllowed = Boolean(
    caseDetails.caseProgressions.find(
      (p) => p.type === "Scanning" && Boolean(p.treatmentPlan)
    )
  );

  const isReviewDesignAllowed =
    user.roles.includes("Dentist") &&
    caseDetails.status === "For design approval";

  const handleDialogOpen = (dialogName) => {
    setIsDialogOpen((prev) => ({ ...prev, [dialogName]: true }));
  };

  const handleDialogClose = (dialogName) => {
    setIsDialogOpen((prev) => ({ ...prev, [dialogName]: false }));
    getCaseStatusData();
  };

  const handlePaymentEmailDialogOpen = () => {
    setOpenPaymentEmail(true);
  };
  const handlePaymentEmailDialogClose = () => {
    setOpenPaymentEmail(false);
    getCaseStatusData();
  };

  const handleSubmitPlanClick = () => {
    navigate("treatment-plan");
  };

  return (
    <StatusGridContainer>
      <GeneratePaymentLinkDialog
        open={openGeneratePaymentLink}
        onClose={handleCloseGeneratePaymentLink}
        caseId={caseDetails?.id}
        caseProgressId={currentCaseProgress?.id}
        currentPaymentLink={currentCaseProgress?.paymentLink}
        modeOfPayment={currentCaseProgress?.termsOfPayment?.modeOfPayment?.name}
      />
      <PaymentEmailDialog
        open={openSendPaymentEmail}
        onClose={handlePaymentEmailDialogClose}
        caseProgressId={currentCaseProgress?.id}
        onEmailSent={handleEmailSent}
        onEmailError={handleEmailError}
      />
      <PayCaseProgressDialog
        openPayCaseProgress={openPayCaseProgress}
        handleClosePayCaseProgress={handleClosePayCaseProgress}
        caseId={caseDetails?.id}
        caseProgressId={currentCaseProgress?.id}
        refresh={getCaseStatusData}
        getPaymentTransactions={getPaymentTransactions}
        amountDue={currentCaseProgress?.amountDue}
      />
      <UpdateDueDateDialog
        openUpdateDueDate={openUpdateDueDate}
        handleCloseUpdateDueDate={handleCloseUpdateDueDate}
        caseProgressId={currentCaseProgress?.id}
        getCaseStatusData={getCaseStatusData}
        caseDetails={caseDetails}
        f2fConsultationInfo={f2fConsultationInfo}
      />
      <StyledH3 theme="lightpurple">Preliminary Steps</StyledH3>
      <Grid
        container
        height="50px"
        spacing={0}
        style={{
          backgroundColor: "#F0F0F0",
          padding: "5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "14px",
          fontFamily: "Inter",
        }}
      >
        <Grid item md={3}>
          Lead
        </Grid>
        <Grid
          item
          md={3}
          style={{
            fontSize: "14px",
            fontFamily: "Inter",
            fontWeight: "600",
          }}
        >
          {leadStatus}
        </Grid>

        <Grid item md={5} style={{ display: "flex" }}>
          {isCaseProgressDone("Lead", caseDetails) === true &&
          leadStatus != null &&
          !isCaseTerminated(caseDetails) ? (
            <DoneIcon />
          ) : isCaseProgressDone("Lead", caseDetails) === true &&
            leadProgressInfo == null &&
            !isCaseTerminated(caseDetails) ? (
            <DoneIcon isNotApplicable={true} />
          ) : (
            <StyledButton
              sx={{
                width: "130px",
              }}
              onClick={() => {
                setDisableButton(true);
                handleDone(leadProgressInfo.id, "lead");
                setDisableButton(false);
              }}
              marginRight="10px"
              theme="green"
              disabled={disableButton}
            >
              Done
            </StyledButton>
          )}
          {leadProgressInfo != null &&
            leadProgressInfo?.caseProgressAppointments?.length > 0 && (
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(leadProgressInfo);
                  handleOpenCommentSection();
                }}
              >
                <FontAwesomeIcon icon={faComment} />
              </ButtonBase>
            )}
        </Grid>
      </Grid>

      <Grid
        container
        spacing={0}
        height="50px"
        style={{
          padding: "5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "14px",
          fontFamily: "Inter",
        }}
      >
        <Grid item md={3}>
          Online Consult
        </Grid>
        <Grid
          item
          md={3}
          style={{
            fontSize: "14px",
            fontFamily: "Inter",
            fontWeight: "600",
          }}
        >
          {onlineConsultStatus}
        </Grid>

        <Grid item md={5} style={{ display: "flex" }}>
          {isOnlineConsultPayRequired && !isCaseTerminated(caseDetails) ? (
            <>
              <StyledButton
                marginRight="10px"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenPayCaseProgress();
                  handleSetCurrentCaseProgress(onlineConsultationInfo);
                }}
                theme="green"
                sx={{
                  width: "130px",
                }}
              >
                Pay
              </StyledButton>
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                  marginRight: "10px",
                }}
                onClick={() => {
                  handleOpenGeneratePaymentLink();
                  handleSetCurrentCaseProgress(onlineConsultationInfo);
                }}
              >
                <FontAwesomeIcon
                  icon={faLink}
                  style={{ paddingRight: "3px" }}
                />
              </ButtonBase>
            </>
          ) : isOnlineConsultEditable && !isCaseTerminated(caseDetails) ? (
            <>
              <StyledButton
                marginRight="10px"
                sx={{
                  width: "130px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(onlineConsultationInfo);
                  setOpenUpdateDueDate(true);
                }}
                theme="green"
              >
                Edit
              </StyledButton>
            </>
          ) : isOnlineConsultDoneAllowed && !isCaseTerminated(caseDetails) ? (
            <>
              <StyledButton
                marginRight="10px"
                sx={{
                  width: "130px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(onlineConsultationInfo);
                  setOpenUpdateDueDate(true);
                }}
                theme="green"
              >
                Edit
              </StyledButton>
              <StyledButton
                sx={{
                  width: "130px",
                }}
                onClick={() => {
                  setDisableButton(true);
                  handleDone(onlineConsultationInfo.id, "online consultation");
                  setDisableButton(false);
                }}
                marginRight="10px"
                theme="green"
                disabled={disableButton}
              >
                Done
              </StyledButton>
            </>
          ) : isCaseProgressDone("For online consultation", caseDetails) ===
              true &&
            onlineConsultationInfo != null &&
            !isCaseTerminated(caseDetails) ? (
            <DoneIcon />
          ) : isCaseProgressDone("For online consultation", caseDetails) ===
              true &&
            onlineConsultationInfo == null &&
            !isCaseTerminated(caseDetails) ? (
            <DoneIcon isNotApplicable={true} />
          ) : null}
          {onlineConsultationInfo != null &&
            onlineConsultationInfo?.caseProgressAppointments?.length > 0 && (
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(onlineConsultationInfo);
                  handleOpenCommentSection();
                }}
              >
                <FontAwesomeIcon icon={faComment} />
              </ButtonBase>
            )}
        </Grid>
      </Grid>
      <Grid
        height="50px"
        container
        spacing={0}
        style={{
          padding: "5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "14px",
          fontFamily: "Inter",
        }}
      >
        <Grid item md={3}>
          F2F Consult
        </Grid>
        <Grid
          item
          md={3}
          style={{
            fontSize: "14px",
            fontFamily: "Inter",
            fontWeight: 600,
          }}
        >
          {f2fConsultStatus}
        </Grid>

        <Grid item md={5} style={{ display: "flex" }}>
          {isF2FConsultPayRequired && !isCaseTerminated(caseDetails) ? (
            isOnlinePayment(
              "F2F Consultation",
              caseDetails.caseProgressions
            ) ? (
              <>
                <StyledButton
                  theme="green"
                  marginRight="10px"
                  onClick={() => {
                    handlePaymentEmailDialogOpen();
                    handleSetCurrentCaseProgress(f2fConsultationInfo);
                  }}
                >
                  Send Payment Email
                </StyledButton>
                <ButtonBase
                  sx={{
                    borderRadius: "80px",
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#161616",
                    color: "white",
                    padding: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    handleOpenGeneratePaymentLink();
                    handleSetCurrentCaseProgress(f2fConsultationInfo);
                  }}
                >
                  <FontAwesomeIcon icon={faLink} />
                </ButtonBase>
              </>
            ) : (
              <>
                <StyledButton
                  marginRight="10px"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenPayCaseProgress();
                    handleSetCurrentCaseProgress(f2fConsultationInfo);
                  }}
                  theme="green"
                  sx={{
                    width: "130px",
                  }}
                >
                  Pay
                </StyledButton>
                <ButtonBase
                  onClick={() => {
                    handleOpenGeneratePaymentLink();
                    handleSetCurrentCaseProgress(f2fConsultationInfo);
                  }}
                  sx={{
                    borderRadius: "80px",
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#161616",
                    color: "white",
                    padding: "10px",
                    marginRight: "10px",
                  }}
                >
                  <FontAwesomeIcon icon={faLink} />
                </ButtonBase>
              </>
            )
          ) : isF2FConsultEditable && !isCaseTerminated(caseDetails) ? (
            <StyledButton
              marginRight="10px"
              sx={{
                width: "130px",
              }}
              onClick={() => {
                handleSetCurrentCaseProgress(f2fConsultationInfo);
                setOpenUpdateDueDate(true);
              }}
              theme="green"
            >
              Edit
            </StyledButton>
          ) : isF2FConsultDoneAllowed && !isCaseTerminated(caseDetails) ? (
            <>
              <StyledButton
                marginRight="10px"
                sx={{
                  width: "130px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(f2fConsultationInfo);
                  setOpenUpdateDueDate(true);
                }}
                theme="green"
              >
                Edit
              </StyledButton>
              <StyledButton
                sx={{
                  width: "130px",
                }}
                onClick={() => {
                  setDisableButton(true);
                  handleDone(f2fConsultationInfo.id, "f2f consultation");
                  setDisableButton(false);
                }}
                marginRight="10px"
                theme="green"
                disabled={disableButton}
              >
                Done
              </StyledButton>
            </>
          ) : isCaseProgressDone("For F2F consultation", caseDetails) ===
              true && !isCaseTerminated(caseDetails) ? (
            <DoneIcon />
          ) : null}
          {f2fConsultationInfo != null &&
            f2fConsultationInfo?.caseProgressAppointments?.length > 0 && (
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(f2fConsultationInfo);
                  handleOpenCommentSection();
                }}
              >
                <FontAwesomeIcon icon={faComment} />
              </ButtonBase>
            )}
        </Grid>
      </Grid>
      <Grid
        container
        height="50px"
        spacing={0}
        style={{
          backgroundColor: "#F0F0F0",
          padding: "5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "14px",
          fontFamily: "Inter",
        }}
      >
        <Grid item md={3}>
          Scan
        </Grid>
        <Grid
          item
          md={3}
          style={{
            fontWeight: 600,
          }}
        >
          {scanUploadStatus}
        </Grid>
        <Grid item md={5} style={{ display: "flex" }}>
          {isScanningPayRequired && !isCaseTerminated(caseDetails) ? (
            isOnlinePayment("Scanning", caseDetails.caseProgressions) ? (
              <>
                <StyledButton
                  theme="green"
                  marginRight="10px"
                  onClick={() => {
                    handlePaymentEmailDialogOpen();
                    handleSetCurrentCaseProgress(scanningInfo);
                  }}
                >
                  Send Payment Email
                </StyledButton>
                <ButtonBase
                  sx={{
                    borderRadius: "80px",
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#161616",
                    color: "white",
                    padding: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    handleSetCurrentCaseProgress(scanningInfo);
                    handleOpenGeneratePaymentLink();
                  }}
                >
                  <FontAwesomeIcon icon={faLink} />
                </ButtonBase>
              </>
            ) : (
              <>
                <StyledButton
                  marginRight="10px"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenPayCaseProgress();
                    handleSetCurrentCaseProgress(scanningInfo);
                  }}
                  theme="green"
                  sx={{
                    width: "130px",
                  }}
                >
                  Pay
                </StyledButton>
                <ButtonBase
                  sx={{
                    borderRadius: "80px",
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#161616",
                    color: "white",
                    padding: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    handleSetCurrentCaseProgress(scanningInfo);
                    handleOpenGeneratePaymentLink();
                  }}
                >
                  <FontAwesomeIcon icon={faLink} />
                </ButtonBase>
              </>
            )
          ) : isScanUploadAllowed && !isCaseTerminated(caseDetails) ? (
            <>
              <StyledButton
                onClick={handleSubmitPlanClick}
                marginRight="10px"
                theme="green"
                sx={{
                  width: "130px",
                }}
              >
                Submit RX Plan
              </StyledButton>
            </>
          ) : isCaseProgressDone("For scanning", caseDetails) === true &&
            !isCaseTerminated(caseDetails) ? (
            <DoneIcon />
          ) : null}
          {scanningInfo != null &&
            scanningInfo?.caseProgressAppointments?.length > 0 && (
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(scanningInfo);
                  handleOpenCommentSection();
                }}
              >
                <FontAwesomeIcon icon={faComment} />
              </ButtonBase>
            )}
        </Grid>
      </Grid>
      <Grid
        container
        height="50px"
        spacing={0}
        style={{
          padding: "5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "14px",
          fontFamily: "Inter",
        }}
      >
        <Grid item md={3}>
          Design
        </Grid>
        <Grid
          item
          md={3}
          style={{
            fontWeight: 600,
          }}
        >
          {designStatus}
        </Grid>

        <Grid item md={5} style={{ display: "flex" }}>
          <>
            {isDesignPayRequired && !isCaseTerminated(caseDetails) ? (
              isOnlinePayment("Design", caseDetails.caseProgressions) ? (
                <>
                  <StyledButton
                    theme="green"
                    marginRight="10px"
                    onClick={() => {
                      handlePaymentEmailDialogOpen();
                      handleSetCurrentCaseProgress(firstDesignCaseProgress);
                    }}
                  >
                    Send Payment Email
                  </StyledButton>
                  <ButtonBase
                    sx={{
                      borderRadius: "80px",
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#161616",
                      color: "white",
                      padding: "10px",
                      marginRight: "10px",
                    }}
                    onClick={() => {
                      handleOpenGeneratePaymentLink();
                      handleSetCurrentCaseProgress(firstDesignCaseProgress);
                    }}
                  >
                    <FontAwesomeIcon icon={faLink} />
                  </ButtonBase>
                </>
              ) : (
                <>
                  <StyledButton
                    marginRight="10px"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenPayCaseProgress();
                      handleSetCurrentCaseProgress(firstDesignCaseProgress);
                    }}
                    theme="green"
                    sx={{
                      width: "130px",
                    }}
                  >
                    Pay
                  </StyledButton>
                  <ButtonBase
                    sx={{
                      borderRadius: "80px",
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#161616",
                      color: "white",
                      padding: "10px",
                      marginRight: "10px",
                    }}
                    onClick={() => {
                      handleOpenGeneratePaymentLink();
                      handleSetCurrentCaseProgress(firstDesignCaseProgress);
                    }}
                  >
                    <FontAwesomeIcon icon={faLink} />
                  </ButtonBase>
                </>
              )
            ) : (
              isDesignSubmissionAllowed &&
              !isCaseTerminated(caseDetails) && (
                <StyledButton
                  marginRight="10px"
                  theme="green"
                  onClick={() => handleDialogOpen("submitDesign")}
                  sx={{
                    width: "130px",
                  }}
                >
                  Submit Design
                </StyledButton>
              )
            )}
            {isCaseProgressDone("For design approval", caseDetails) &&
              !isCaseTerminated(caseDetails) && <DoneIcon />}

            {isViewRxAllowed && !isCaseTerminated(caseDetails) && (
              <StyledButton
                marginRight="10px"
                theme="green"
                onClick={() => handleDialogOpen("viewTreatmentPlan")}
                sx={{
                  width: "130px",
                }}
              >
                View RX Plan
              </StyledButton>
            )}
          </>
          {firstDesignCaseProgress != null &&
            firstDesignCaseProgress?.caseProgressAppointments?.length > 0 && (
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(firstDesignCaseProgress);
                  handleOpenCommentSection();
                }}
              >
                <FontAwesomeIcon icon={faComment} />
              </ButtonBase>
            )}
        </Grid>
      </Grid>
      <Grid
        container
        height="50px"
        spacing={0}
        style={{
          backgroundColor: "#F0F0F0",
          padding: "5px",
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "14px",
          fontFamily: "Inter",
        }}
      >
        <Grid item md={3}>
          Review Design
        </Grid>
        <Grid
          item
          md={3}
          style={{
            fontWeight: 600,
          }}
        >
          {reviewDesignStatus}
        </Grid>
        <Grid item md={5} style={{ display: "flex" }}>
          {isCaseProgressDone("For design approval", caseDetails) &&
            !isCaseTerminated(caseDetails) && <DoneIcon />}

          {isReviewDesignPayRequired && !isCaseTerminated(caseDetails) ? (
            <StyledButton
              marginRight="10px"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenPayCaseProgress();
                handleSetCurrentCaseProgress(firstReviewCaseProgress);
              }}
              theme="green"
              sx={{
                width: "130px",
              }}
            >
              Pay
            </StyledButton>
          ) : isReviewDesignAllowed && !isCaseTerminated(caseDetails) ? (
            <>
              <StyledButton
                marginRight="10px"
                theme="green"
                onClick={() => handleDialogOpen("reviewDesign")}
                sx={{
                  width: "130px",
                }}
              >
                Review
              </StyledButton>
            </>
          ) : isEditSetsAllowed && !isCaseTerminated(caseDetails) ? (
            <StyledButton
              marginRight="10px"
              onClick={() => handleOpenUpdateNoOfSets()}
              theme="green"
            >
              Edit No. of Sets
            </StyledButton>
          ) : null}
          {isViewReviewAllowed && !isCaseTerminated(caseDetails) && (
            <StyledButton
              marginRight="10px"
              theme="green"
              onClick={() => handleDialogOpen("viewReview")}
              sx={{
                width: "130px",
              }}
            >
              View Review
            </StyledButton>
          )}
          {firstReviewCaseProgress != null &&
            firstReviewCaseProgress?.caseProgressAppointments?.length > 0 && (
              <ButtonBase
                sx={{
                  borderRadius: "80px",
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#161616",
                  color: "white",
                  padding: "10px",
                }}
                onClick={() => {
                  handleSetCurrentCaseProgress(firstReviewCaseProgress);
                  handleOpenCommentSection();
                }}
              >
                <FontAwesomeIcon icon={faComment} />
              </ButtonBase>
            )}
        </Grid>
      </Grid>
      {/* Dialogs */}
      <SubmitDesignDialog
        caseId={caseDetails.id}
        open={isDialogOpen.submitDesign}
        onClose={() => handleDialogClose("submitDesign")}
      />
      <ReviewDesignDialog
        caseId={caseDetails.id}
        open={isDialogOpen.reviewDesign}
        onClose={() => handleDialogClose("reviewDesign")}
        patientName={
          caseDetails.patient.firstName + "_" + caseDetails.patient.lastName
        }
      />
      <ViewReviewDialog
        caseDetails={caseDetails}
        open={isDialogOpen.viewReview}
        onClose={() => handleDialogClose("viewReview")}
      />
      <ViewTreatmentPlanDialog
        caseDetails={caseDetails}
        open={isDialogOpen.viewTreatmentPlan}
        onClose={() => handleDialogClose("viewTreatmentPlan")}
      />
    </StatusGridContainer>
  );
};

export default CaseStatusGrid;
